import { render, staticRenderFns } from "./UploadTemplateModal.vue?vue&type=template&id=67fd821d"
import script from "./UploadTemplateModal.vue?vue&type=script&lang=ts"
export * from "./UploadTemplateModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67fd821d')) {
      api.createRecord('67fd821d', component.options)
    } else {
      api.reload('67fd821d', component.options)
    }
    module.hot.accept("./UploadTemplateModal.vue?vue&type=template&id=67fd821d", function () {
      api.rerender('67fd821d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sale-layout-editor/UploadTemplateModal.vue"
export default component.exports